<div class="addContainer form-dialog">
  <div class="modalHeader form-dialog__header">
    <div class="avatarDetails">
      <div class="modalTitle">
        {{ data.title }}
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="modal-close-button" [attr.aria-label]="'formDialog.close' | translate" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="form-dialog__content">
    <form class="register-form form-dialog__form" [formGroup]="form" (ngSubmit)="submit()">
      <div class="row form-dialog__grid">
        @for (field of data.fields; track field.key) {
        @if (shouldShowField(field)) {
        <div class="form-dialog__field"
             [class.col-12]="field.fullWidth"
             [class.col-xl-6]="!field.fullWidth"
             [class.col-lg-6]="!field.fullWidth"
             [class.col-md-12]="!field.fullWidth"
             [class.col-sm-12]="!field.fullWidth">
          @switch (field.type) {
            @case ('textarea') {
            <mat-form-field subscriptSizing="dynamic" class="example-full-width" appearance="outline">
              <mat-label>{{ field.label }}</mat-label>
              <textarea
                matInput
                [rows]="field.rows || 3"
                [placeholder]="field.placeholder || ''"
                [attr.data-allow-unicode]="field.allowUnicode ? 'true' : null"
                [attr.data-preserve-case]="field.preserveCase ? 'true' : null"
                (input)="sanitizeTextInput(field, $event)"
                [formControlName]="field.key"></textarea>
              @if (field.hint) {
              <mat-hint>{{ field.hint }}</mat-hint>
              }
              @if (hasRequiredError(field.key)) {
              <mat-error>{{ 'formDialog.required' | translate:{ field: field.label } }}</mat-error>
              } @else if (hasMinLengthError(field)) {
              <mat-error>{{ 'formDialog.minLength' | translate:{ field: field.label, count: field.minLength } }}</mat-error>
              }
            </mat-form-field>
            }
            @case ('select') {
            <mat-form-field subscriptSizing="dynamic" class="example-full-width" appearance="outline">
              <mat-label>{{ field.label }}</mat-label>
              <mat-select [formControlName]="field.key"
                          [multiple]="field.multiple"
                          (openedChange)="handleSelectOpenedChange(field.key, $event)">
                <mat-option class="form-dialog__select-search-option"
                            disabled>
                  <input matInput
                         [(ngModel)]="selectSearch[field.key]"
                         [ngModelOptions]="{ standalone: true }"
                         [placeholder]="'formDialog.searchOption' | translate"
                         class="form-dialog__select-search-input"
                         (click)="$event.stopPropagation()"
                         (keydown)="$event.stopPropagation()"
                         (keyup)="$event.stopPropagation()">
                </mat-option>
                @for (option of getFilteredOptions(field); track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
              @if (field.hint) {
              <mat-hint>{{ field.hint }}</mat-hint>
              }
              @if (hasRequiredError(field.key)) {
              <mat-error>{{ 'formDialog.required' | translate:{ field: field.label } }}</mat-error>
              } @else if (hasMinLengthError(field)) {
              <mat-error>{{ 'formDialog.minLength' | translate:{ field: field.label, count: field.minLength } }}</mat-error>
              }
            </mat-form-field>
            }
            @case ('autocomplete') {
            <mat-form-field subscriptSizing="dynamic" class="example-full-width" appearance="outline">
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                #autocompleteTrigger="matAutocompleteTrigger"
                [ngModel]="getAutocompleteSearchValue(field.key)"
                [ngModelOptions]="{ standalone: true }"
                [matAutocomplete]="autocompleteRef"
                [placeholder]="field.placeholder || ''"
                autocomplete="off"
                (ngModelChange)="handleAutocompleteInput(field, $event)"
                (focus)="void openAutocomplete(field); autocompleteTrigger.openPanel()"
                (click)="void openAutocomplete(field); autocompleteTrigger.openPanel()">
              <button mat-icon-button
                      matSuffix
                      type="button"
                      tabindex="-1"
                      (click)="void openAutocomplete(field); autocompleteTrigger.openPanel()">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #autocompleteRef="matAutocomplete">
                @for (option of getAutocompleteOptions(field.key); track option.value) {
                <mat-option [value]="option.label"
                            (onSelectionChange)="$event.source.selected && handleAutocompleteSelected(field, option)">
                  {{ option.label }}
                </mat-option>
                }
              </mat-autocomplete>
              @if (field.hint) {
              <mat-hint>{{ field.hint }}</mat-hint>
              }
              @if (hasRequiredError(field.key)) {
              <mat-error>{{ 'formDialog.required' | translate:{ field: field.label } }}</mat-error>
              }
            </mat-form-field>
            }
            @case ('toggle') {
            <div class="form-dialog__toggle-card">
              <div class="form-dialog__toggle-copy">
                <strong>{{ field.label }}</strong>
                @if (field.hint) {
                <p>{{ field.hint }}</p>
                }
              </div>
              <mat-slide-toggle [formControlName]="field.key">
              </mat-slide-toggle>
            </div>
            }
            @case ('file') {
            <div class="form-dialog__file-card">
              <div class="form-dialog__file-copy">
                <strong>{{ field.label }}</strong>
                @if (field.hint) {
                <p>{{ field.hint }}</p>
                }
              </div>

              <div class="form-dialog__file-body">
                @if (getFilePreview(field.key)) {
                <img [src]="getFilePreview(field.key)"
                     [alt]="field.label"
                     class="form-dialog__file-preview" />
                } @else {
                <div class="form-dialog__file-placeholder">
                  <mat-icon>person</mat-icon>
                </div>
                }

                <div class="form-dialog__file-actions">
                  <label class="form-dialog__file-button">
                    <input type="file"
                           class="form-dialog__file-input"
                           [accept]="field.accept || 'image/*'"
                           (change)="handleFileSelected(field.key, $event)">
                    <span>{{ 'formDialog.selectImage' | translate }}</span>
                  </label>

                  @if (getSelectedFileName(field.key)) {
                  <small class="form-dialog__file-name">{{ getSelectedFileName(field.key) }}</small>
                  } @else if (getFilePreview(field.key)) {
                  <small class="form-dialog__file-name">{{ 'formDialog.currentImage' | translate }}</small>
                  }
                </div>
              </div>
            </div>
            }
            @case ('color') {
            <div class="form-dialog__color-card">
              <label class="form-dialog__color-label" [for]="field.key + '-picker'">{{ field.label }}</label>
              <div class="form-dialog__color-control">
                <input class="form-dialog__color-picker"
                       [id]="field.key + '-picker'"
                       type="color"
                       [formControlName]="field.key">
                <input class="form-dialog__color-value"
                       type="text"
                       maxlength="7"
                       spellcheck="false"
                       [placeholder]="field.placeholder || '#000000'"
                       [formControlName]="field.key">
              </div>
              @if (field.hint) {
              <small class="form-dialog__color-hint">{{ field.hint }}</small>
              }
              @if (form.get(field.key)?.touched && form.get(field.key)?.hasError('pattern')) {
              <small class="form-dialog__color-error">{{ 'formDialog.invalidColor' | translate }}</small>
              }
            </div>
            }
            @default {
            <mat-form-field subscriptSizing="dynamic" class="example-full-width" appearance="outline">
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                [type]="field.type === 'number' ? 'number' : 'text'"
                [placeholder]="field.placeholder || ''"
                [attr.data-allow-unicode]="field.allowUnicode ? 'true' : null"
                [attr.data-preserve-case]="field.preserveCase ? 'true' : null"
                (input)="sanitizeTextInput(field, $event)"
                [formControlName]="field.key">
              @if (field.hint) {
              <mat-hint>{{ field.hint }}</mat-hint>
              }
              @if (hasRequiredError(field.key)) {
              <mat-error>{{ 'formDialog.required' | translate:{ field: field.label } }}</mat-error>
              } @else if (hasMinLengthError(field)) {
              <mat-error>{{ 'formDialog.minLength' | translate:{ field: field.label, count: field.minLength } }}</mat-error>
              }
            </mat-form-field>
            }
          }
        </div>
        }
        }
      </div>

      <div class="row form-dialog__footer-row">
        <div class="col-12">
          <div class="example-button-row form-dialog__actions">
            <button mat-flat-button class="formSubmitBtn btn-tone-primary" [disabled]="form.invalid || isSubmitting" type="submit">
              {{ data.submitLabel || ('formDialog.save' | translate) }}
            </button>
            <button mat-flat-button mat-dialog-close class="formCancelBtn btn-tone-neutral" [disabled]="isSubmitting" type="button">
              {{ 'formDialog.cancel' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
